'use strict';

var Util = require("../layouts/util.js");
var React = require("react");
var ReasonReact = require("reason-react/src/ReasonReact.js");
var SpeakerCardModuleScss = require("./speakerCard.module.scss");

var component = ReasonReact.statelessComponent("SpeakerCard");

function make(speaker, $staropt$star, _) {
  var compact = $staropt$star ? $staropt$star[0] : false;
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */component[/* willReceiveProps */3],
          /* didMount */component[/* didMount */4],
          /* didUpdate */component[/* didUpdate */5],
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function () {
              return React.createElement("figure", {
                          className: compact ? SpeakerCardModuleScss.compact : SpeakerCardModuleScss.root
                        }, React.createElement("img", {
                              alt: speaker[/* name */0],
                              src: speaker[/* imgUrl */2]
                            }), React.createElement("figcaption", {
                              className: SpeakerCardModuleScss.description
                            }, React.createElement("h3", {
                                  className: SpeakerCardModuleScss.name
                                }, Util.s(speaker[/* name */0])), React.createElement("p", {
                                  className: SpeakerCardModuleScss.company
                                }, Util.s(speaker[/* company */1]))));
            }),
          /* initialState */component[/* initialState */10],
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */component[/* reducer */12],
          /* subscriptions */component[/* subscriptions */13],
          /* jsElementWrapped */component[/* jsElementWrapped */14]
        ];
}

exports.component = component;
exports.make = make;
/* component Not a pure module */



// WEBPACK FOOTER //
// ./src/components/speakerCard.js